import axios from 'axios';

export const releaseTransactionProofs = (caseId, transactionIds) => {
    return axios.post('/api/releaseTransactionProofs', {
        caseId,
        transactionIds,
    });
};
